import articlesReducer, { ArticlesState } from 'mk2/apps/blogs/containers/Article/Article.reducers';
import { ArticleCreateState } from 'mk2/apps/blogs/containers/ArticleCreate/ArticleCreate.reducers';
import { ArticleEditsState } from 'mk2/apps/blogs/containers/ArticleEdit/ArticleEdit.reducers';
import { BlogsEntityLikersState } from 'mk2/apps/blogs/containers/BlogsEntityLikers/BlogsEntityLikers.reducers';
import { BlogsShortMessageDetailPagesState } from 'mk2/apps/blogs/containers/BlogsShortMessageDetail/BlogsShortMessageDetail.reducers';
import { BlogsShortMessageEditPagesState } from 'mk2/apps/blogs/containers/BlogsShortMessageEdit/BlogsShortMessageEdit.reducers';
import * as fromBlogsComments from 'mk2/apps/blogs/containers/Comments/Comments.reducers';
import * as fromLikeInfoPopup from 'mk2/apps/blogs/containers/LikeInfoPopup/LikeInfoPopup.reducers';
import * as fromLikeSection from 'mk2/apps/blogs/containers/LikeSection/LikeSection.reducers';
import * as fromBlogsUserStrollers from 'mk2/apps/blogs/containers/UserStrollersWidget/UserStrollersWidget.reducers';
import { AppState } from 'mk2/reducers';
import { combineReducers } from 'redux';

interface BlogsSharedState {
    comments: fromBlogsComments.PostsState;
    blogArticles: ArticlesState;
    likeInfoPopups: fromLikeInfoPopup.LikeInfoPopupsState;
    likeSections: fromLikeSection.LikeSectionsState;
    userStrollers: fromBlogsUserStrollers.UserStrollersState;
}

const blogsSharedReducer = combineReducers<BlogsSharedState>({
    comments: fromBlogsComments.postsReducer,
    blogArticles: articlesReducer,
    likeInfoPopups: fromLikeInfoPopup.likeInfoPopupsReducer,
    likeSections: fromLikeSection.likeSectionsReducer,
    userStrollers: fromBlogsUserStrollers.userStrollersReducer,
});

export interface BlogsAppState {
    shared: BlogsSharedState;
    blogsArticles: ArticlesState;
    blogsArticleEdits: ArticleEditsState;
    blogsArticleCreates: ArticleCreateState;
    blogsEntityLikers: BlogsEntityLikersState;
    blogsShortMessageDetails: BlogsShortMessageDetailPagesState;
    blogsShortMessageEdits: BlogsShortMessageEditPagesState;
}

export const blogsReducer = {
    shared: blogsSharedReducer,
};

// Export selectors for LikeInfoPopup in blogs
export const getLikeInfoPopupState = (state: AppState, entityType: string, entityId: number): fromLikeInfoPopup.LikeInfoPopupState =>
    state.containers.blogs.shared.likeInfoPopups[`${entityType}/${entityId}`] || fromLikeInfoPopup.initialLikeInfoPopupState;

// Export selectors for LikeSection in blogs
export const getLikeSectionState = (state: AppState, entityType: string, entityId: number): fromLikeSection.LikeSectionState =>
    state.containers.blogs.shared.likeSections[`${entityType}/${entityId}`] || fromLikeSection.initialLikeSectionState;

// Export selectors for UserStrollersWidget in blogs
export const getBlogsUserStrollerState = (state: AppState): fromBlogsUserStrollers.UserStrollersState =>
    state.containers.blogs.shared.userStrollers;
